<template>
  <button :type="type" class="btn-link" @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
  export default {
    name: 'ButtonLink',
    props: {
      type: {
        type: String,
        default: 'button',
      },
    },
  };
</script>
